
<div>
  <app-base-report *ngIf="invoiceSalesData"
                  [filterFields]="filterField"
                   [reportName]="reportName"
                   [defaultColumns]="tableColumns"
                   [columnsDisplayNames]="displayTableColumns"
                   [data]="invoiceSalesData"
                   [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)"
                   (paginationChange)="paginate($event)"
                   (searchChange)="searchChange($event)"
                   [tableLoading]="loading"
                   [hasSort]="true"
                   (sortTrigger)="sortChange($event)"
                   [serviceInstance]="invoiceSalesReport"></app-base-report>
</div>
